export function checkLocalStorageSupport() {
	let hasLocalStorageSupport;
	try {
		hasLocalStorageSupport = 'localStorage' in window && window.localStorage !== null;
		let testKey = 'storageTest';
		window.localStorage.setItem(testKey, 'foo');
		window.localStorage.removeItem(testKey);
	} catch (e) {
		hasLocalStorageSupport = false;
	}

	if (!hasLocalStorageSupport) {
		delete window.localStorage;
		window.localStorage = {};
		window.localStorage.items = {};
		window.localStorage.getItem = key => {
			return window.localStorage.items[key] || null;
		};
		window.localStorage.removeItem = key => {
			delete window.localStorage.items[key];
		};
		window.localStorage.setItem = (key, value) => {
			window.localStorage.items[key] = value;
		}
	}

	let hasSessionStorageSupport;
	try {
		hasSessionStorageSupport = 'sessionStorage' in window && window.sessionStorage !== null;
		let testKey = 'storageTest';
		window.sessionStorage.setItem(testKey, 'foo');
		window.sessionStorage.removeItem(testKey);
	} catch (e) {
		hasSessionStorageSupport = false;
	}

	if (!hasSessionStorageSupport) {
		delete window.sessionStorage;
		window.sessionStorage = {};
		window.sessionStorage.items = {};
		window.sessionStorage.getItem = key => {
			return window.sessionStorage.items[key] || null;
		};
		window.sessionStorage.removeItem = key => {
			delete window.sessionStorage.items[key];
		};
		window.sessionStorage.setItem = (key, value) => {
			window.sessionStorage.items[key] = value;
		}
	}
}